<app-banner [heading]="'CONTACT US'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    <!-- ======= Services Section ======= -->
    <section id="services" class="services section-bg">
      <div class="container">

        <header class="section-header">
          <h2>PLAN YOUR CHILD'S FUTURE WITH TAGORE GLOBAL SCHOOL </h2>
          <p>One of the Growing &amp; Future Ready School affiliated to CBSE New Delhi equipped with Ultra Modern Facilities</p>
        </header>

        <div class="row">

          <div class="col-md-6 col-lg-4 " >
            <div class="box">
              <div class="icon" style="background: #fceef3;"><i class="fa-thin fa-chart-pie" style="color: #ff689b;"></i></div>
              <h4 class="title"><a href="">Our Address</a></h4>
              <p class="description">Tagore Global School</p>
			  <p class="description">Sector 29, Global City</p>
			  <p class="description">Kurukshetra - Haryana </p>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 " >
            <div class="box">
              <div class="icon" style="background: #fceef3;"><i class="fa-thin fa-chart-pie" style="color: #ff689b;"></i></div>
              <h4 class="title"><a href="">Contact No's</a></h4>
              <p class="description"> Reception - 7082346751 <br>Manager - 9303350002</p>
			  <p class="description"> Principal - 9050926751</p>
			  
			  
            </div>
          </div>

          <div class="col-md-6 col-lg-4 " >
            <div class="box">
              <div class="icon" style="background: #fceef3;"><i class="fa-thin fa-chart-pie" style="color: #ff689b;"></i></div>
              <h4 class="title"><a href="">Email Us</a></h4>
              <p class="description">Email : tgskkr18@gmail.com</p>
			  <p class="description">Visit : www.tagoreglobalschool.in</p>
            </div>
          </div>
		  <div class="col-lg-6 " id="contactusimage" >
            <img src="assets/img/misc/contactus1.jpg" class="img-fluid" alt="Furniture and House Movers in hamilton">
          </div>
		  
		  
		  <div class="col-lg-6">
		  <div class="main">
		<div class="info">Get in touch with us !</div>
		<form #contactForm="ngForm" (ngSubmit)="onSubmit(contactForm)" name="form" class="form-box">
			<label for="name">Name</label><br>
			<input type="text" name="name" class="inp" placeholder="Enter Your Name" ngModel id="name" minlength="2" required><br>
			<label for="email">Email ID</label><br>
			<input type="email" name="email" class="inp" placeholder="Enter Your Email"  required 
      email
      ngModel><br>
			<label for="phone">Phone</label><br>
			<input type="tel" name="phone" class="inp" placeholder="Enter Your Phone" required
      minlength="10"
      maxlength="10"
      ngModel><br>
			<label for="message">Message</label><br>
			<textarea name="message" class="msg-box" placeholder="Enter Your Message Here..." required
      minlength="3"
      ngModel></textarea><br>
			<input type="submit" name="submit" value="Send" class="sub-btn">
		</form>
	</div>
		  </div>
        </div>
	</div>
    </section><!-- End Services Section -->
	
	
	
	
    
    
  </main>